import { render, staticRenderFns } from "./CreateInvoicesModal.vue?vue&type=template&id=15189e49&scoped=true&"
import script from "./CreateInvoicesModal.vue?vue&type=script&lang=js&"
export * from "./CreateInvoicesModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateInvoicesModal.vue?vue&type=style&index=0&id=15189e49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15189e49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15189e49')) {
      api.createRecord('15189e49', component.options)
    } else {
      api.reload('15189e49', component.options)
    }
    module.hot.accept("./CreateInvoicesModal.vue?vue&type=template&id=15189e49&scoped=true&", function () {
      api.rerender('15189e49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CustomerInvoices/components/CreateInvoicesModal.vue"
export default component.exports